import { combineReducers } from "redux";

import { generalReducer } from "../services/general/reducer";

import { stepOneReducer } from "./One/services/reducer";

export const configManagerLiteReducer = combineReducers({
    general: generalReducer,
    stepOne: stepOneReducer
});
